import ProjectsList from '~/projects_list';

document.addEventListener('DOMContentLoaded', () => {
  new ProjectsList(); // eslint-disable-line no-new
});
